export const GoogleMapApiConfig = 'AIzaSyA0FpNkiqHebUPq7DmzTAxLVh_e7cYXz7w';